import React from "react";
import Card from "@/components/Card";

import { Form, Select } from "antd";
import { useRootSelector } from "@/infrastructure/hooks";
import { BacktestAction, BacktestSel } from "@/features/backtest";
import { useDispatch } from "react-redux";

const { Option } = Select;

export default () => {
  const dispatch = useDispatch();
  const stock_peer = useRootSelector(BacktestSel.stock_peer);
  const index_peer = useRootSelector(BacktestSel.index_peer);
  const availTickers = useRootSelector(BacktestSel.availTickers);
  const availIndices = useRootSelector(BacktestSel.availIndices);
  const isTickerLoading = useRootSelector(BacktestSel.isTickerLoading);
  const region = useRootSelector(BacktestSel.region);

  return (
    <Card title={"Comparison Options"}>
      <Form.Item label="Select Peer" name={"stock_peer"} rules={[{ required: false }]} initialValue={stock_peer}>
        <Select
          showSearch
          loading={isTickerLoading}
          mode={"multiple"}
          placeholder="Search and select a peer (optional)"
          style={{ width: "93%" }}
          filterOption={false}
          onChange={e => dispatch(BacktestAction.updateSetup({ stock_peer: e as string[] }))}
          onSearch={e => dispatch(BacktestAction.fetchTickers.request({ region, text: e }))}
        >
          {availTickers.map(e => (
            <Option key={e.symbol} value={e.symbol}>
              [{e.symbol}] {e.shortname || e.longname}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item label="Select Index" name={"index_peer"} rules={[{ required: false }]} initialValue={index_peer}>
        <Select
          mode={"multiple"}
          placeholder="Search and select an index (optional)"
          style={{ width: "93%" }}
          onChange={e => dispatch(BacktestAction.updateSetup({ index_peer: e as string[] }))}
        >
          {availIndices.map(e => (
            <Option key={e.symbol} value={e.symbol}>
              [{e.symbol}] {e.name}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </Card>
  );
};
